import type { MeResponse } from '@ucp/web/lib';
import { hasAnyRole } from '../shell/navConfig';
import { Card } from '../ui/Card';
import { SentActivitySection } from './SentActivitySection';

/**
 * Role-aware Home (PRO-0250; reskinned PRO-0260 Phase 2; launchpad retired PRO-0620
 * follow-up). Navigation, the account identity and the active-school selector all live
 * in the top chrome (ADR-014), so Home drops the redundant page-header / active-school
 * block (title, "Welcome, …", "Active school: …") and keeps only an sr-only h1 for
 * accessibility. For a single-school sender it surfaces the "Sent" activity overview
 * (PRO-0620); "What needs my attention" stays an explicit empty state at Inc 1 — counts
 * are Wave-8 data (Debt-4). No-role users never reach here (AccessGate, D2).
 */
export function HomeView({ user }: { user: MeResponse }) {
  // PRO-0620 — the sent-activity overview enriches Home for a single-school sender
  // only, behind the default-off flag. The server gate (`requireCommsHomeActivityEnabled`
  // + `compose_send` + single-tenant) stays authoritative; this just avoids mounting
  // the fetch for users who could never see it. `SentActivitySection` owns the hook.
  const showSentActivity =
    user.featureFlags.commsHomeActivityEnabled && hasAnyRole(user, ['L1_SENDER']);

  return (
    <section aria-labelledby="home-heading">
      <h1 id="home-heading" className="sr-only">
        Home
      </h1>

      {showSentActivity ? <SentActivitySection /> : null}

      <h2 className="mb-3 mt-8 text-lg font-semibold text-text-primary">What needs my attention</h2>
      <Card className="max-w-narrow p-6">
        <p className="m-0 text-base text-text-secondary">
          Attention counts will appear here in a later wave.
        </p>
      </Card>
    </section>
  );
}
